import {triggersApi} from '../api';
import CrmSyncActions from 'actions/crm/CrmSyncActions';

/** CallCrmSupportsCloudSource implements interactions with the crm-supports-cloud endpoint */
const CallCrmSupportsCloudSource = {
  crmSupportsCloud: {
    remote(state) {
      return triggersApi.get(`/add_crm_data_to_call/supported`);
    },
    loading: CrmSyncActions.crmSupportsCloudLoading,
    success: CrmSyncActions.crmSupportsCloudSuccess,
    error: CrmSyncActions.crmSupportsCloudLoadingError,
  },
};

export default CallCrmSupportsCloudSource;
